import { render, staticRenderFns } from "./finrecinfotab.vue?vue&type=template&id=71e98c9e&scoped=true&"
import script from "./finrecinfotab.vue?vue&type=script&lang=js&"
export * from "./finrecinfotab.vue?vue&type=script&lang=js&"
import style0 from "./finrecinfotab.vue?vue&type=style&index=0&id=71e98c9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e98c9e",
  null
  
)

export default component.exports